export const basicUsage: string = `
    import React from 'react';
    import { ProgressBar } from 'ms-react-progress-bar';
    import 'ms-react-progress-bar/dist/ProgressBar.css';
  
    function App(){
        return (
            <div>
                <ProgressBar value={40} />
            </div>
        );
    }
`;

export const withOptions: string = `
    import React from 'react';
    import { ProgressBar } from 'ms-react-progress-bar';
    import 'ms-react-progress-bar/dist/ProgressBar.css';
  
    function App(){
        const options = {
            height: "30px",
            borderRadius: "20px",
            labelSize: "14px",
            barColor: "#2c43ac",
            containerColor: "#dddddd",
            containerStyle: "border",
            stripeAnimation: true,
            stripeAnimationDuration: '20s',
            type: "striped",
        }
        return (
            <div>
                <ProgressBar value={80} options={options} />
            </div>
        );
    }
`;


export const imports: string = `import { ProgressBar } from 'ms-react-progress-bar';
import 'ms-react-progress-bar/dist/ProgressBar.css';
`;